import { render, staticRenderFns } from "./poetdetail.vue?vue&type=template&id=d5869f32&"
import script from "./poetdetail.vue?vue&type=script&lang=js&"
export * from "./poetdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports